// Drafts of open forms survive an expired session in this browser tab only (sessionStorage), per user and form.
const PREFIX = "visibilis:draft:";
const RETURN = "visibilis:return";
const SKIP = new Set(["file", "password"]);

export const draftKey = (userId, testId) => `${PREFIX}${userId}:${window.location.pathname}:${testId}`;

export function saveDraft(key, fields, values, base) {
  const keep = {};
  fields.forEach((f) => {
    if (!f.name || SKIP.has(f.type)) return;
    if (JSON.stringify(values[f.name]) !== JSON.stringify(base[f.name])) keep[f.name] = values[f.name];
  });
  if (Object.keys(keep).length) sessionStorage.setItem(key, JSON.stringify(keep));
}

export function peekDraft(key) {
  try {
    return JSON.parse(sessionStorage.getItem(key) || "null");
  } catch (_) {
    return null;
  }
}

export const dropDraft = (key) => sessionStorage.removeItem(key);

export function clearDrafts() {
  Object.keys(sessionStorage).filter((k) => k.startsWith(PREFIX) || k === RETURN).forEach((k) => sessionStorage.removeItem(k));
}

export function rememberReturn() {
  const path = window.location.pathname + window.location.search;
  if (path !== "/login") sessionStorage.setItem(RETURN, path);
}

export function returnPath() {
  const path = sessionStorage.getItem(RETURN) || "/";
  return /^\/(?!\/)/.test(path) ? path : "/";
}

export const clearReturn = () => sessionStorage.removeItem(RETURN);
